
import Vue from 'vue'

import CustomTextModal from './CustomTextModal.vue'
import { RButton, RStars, RInput } from '@/components'

import { WorkstationUsageSurveyForm } from '@/api/surveys'

const SCORE_NOT_GIVEN = 0 // sentinel score value

type WorkstationUsageFeedback = {
  score: number
  description?: string
  workstationUuid: string
}

export default Vue.extend({
  name: 'WorkstationUsageSurveyModal',
  components: {
    CustomTextModal,
    RButton,
    RStars,
    RInput,
  },
  data(): WorkstationUsageFeedback {
    return {
      score: SCORE_NOT_GIVEN,
      description: '',
      workstationUuid: 'not_passed_in_yet',
    }
  },

  methods: {
    handleSubmit(): void {
      const { canSubmit } = this
      if (!canSubmit) return // something must have gone wrong
      const { score, description, workstationUuid } = this
      let objectToSubmit: WorkstationUsageSurveyForm = { score, workstationUuid }
      if (description) {
        objectToSubmit = { ...objectToSubmit, description }
      }
      this.$emit('submit', objectToSubmit)
    },

    // Hook used to assign proper workstation uuid
    handleBeforeShow(uuid: string): void {
      this.workstationUuid = uuid
    },

    clearInputs(): void {
      this.score = SCORE_NOT_GIVEN
      this.description = ''
    },
  },
  computed: {
    showDescriptionInput(): boolean {
      const { score, canSubmit } = this
      return canSubmit && score < 4
    },
    canSubmit(): boolean {
      return this.score !== SCORE_NOT_GIVEN // default is 0, cannot be picked
    },
  },
})
